import { ComponentProps } from 'react';
import clsx from 'clsx';
import Transfer from 'antd/es/transfer';
import { useTranslation } from 'react-i18next';

import './OpTransfer.scss';

interface OpTransferProps extends ComponentProps<typeof Transfer> {
  testId?: string;
}

export const OpTransfer = ({
  className,
  testId = 'op-transfer',
  ...elementProps
}: OpTransferProps) => {
  const { t } = useTranslation();

  return (
    // Currently antd doesn't support data-testid being directly added to the component
    <div data-testid={testId}>
      <Transfer
        className={clsx('op-transfer', className)}
        titles={[
          <strong key="available">{t('AVAILABLE')}</strong>,
          <strong key="existing">{t('EXISTING')}</strong>,
        ]}
        {...elementProps}
      />
    </div>
  );
};
